import { SxProps, Theme } from '@mui/material';

export const LoaderStyle: SxProps<Theme> = {
  boxShadow: 'none',
  height: '100%',
  inset: 0,
  opacity: 0.8,
  overflow: 'auto',
  position: 'absolute',
  width: '100%',
  zIndex: 10,
};
